export const formatLocalDateTime = (value?: string | number | Date | null) => {
  if (value === undefined || value === null) return '-';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(date);
};

export const formatTimezoneOffset = (offsetMinutes?: number) => {
  if (offsetMinutes === undefined || offsetMinutes === null) return '';
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absMinutes = Math.abs(offsetMinutes);
  const hours = Math.floor(absMinutes / 60);
  const minutes = absMinutes % 60;
  return `UTC${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
};

export const formatLocalDate = (value: Date): string => {
  const year = value.getFullYear();
  const month = (value.getMonth() + 1).toString().padStart(2, '0');
  const day = value.getDate().toString().padStart(2, '0');
  return `${year}/${month}/${day}`;
};

export const formatLocalDateWithTime = (value: Date): string => {
  const base = formatLocalDate(value);
  const hours = value.getHours().toString().padStart(2, '0');
  const minutes = value.getMinutes().toString().padStart(2, '0');
  const seconds = value.getSeconds().toString().padStart(2, '0');
  return `${base} ${hours}:${minutes}:${seconds}`;
};

export const formatNumber = (num: number): string => {
  if (isNaN(num) || !isFinite(num)) return '0';
  return num.toLocaleString();
};

export const formatCurrency = (amount: number): string => {
  if (isNaN(amount) || !isFinite(amount)) return '$0.00';
  return `$${amount.toFixed(2)}`;
};

export const formatPercentage = (percentage: number): string => {
  if (isNaN(percentage) || !isFinite(percentage)) return '0.00%';
  return `${percentage.toFixed(2)}%`;
};
